import { LightningElement, api, wire } from "lwc";
import classNames from "classnames";

import { LabelsAdapter, LabelsAdapterValue } from "common/labelsAdapter";
import {
  AnimationAdapter,
  AnimationAdapterValue,
} from "common/animationAdapter";

import * as locales from "./locales";

const DEFAULT_SIZE = "medium";
const DEFAULT_VARIANT = "base";

export default class extends LightningElement {
  @api size: "xx-small" | "x-small" | "small" | "medium" | "large" =
    DEFAULT_SIZE;

  @api variant: "base" | "brand" | "inverse" = DEFAULT_VARIANT;

  private get className() {
    return classNames(
      `spinner spinner--${this.size} spinner--${this.variant}`,
      {
        animated: this.animation.enabled,
      }
    );
  }

  @wire(LabelsAdapter, { locales })
  private labels: LabelsAdapterValue = null!;

  @wire(AnimationAdapter)
  private animation: AnimationAdapterValue = null!;
}
